import React, { useState } from 'react'

export const useChatImageUpload = () => {

    const [image, setImage] = useState<File | null>(null)
    const [showImageModal, setShowImageModal] = useState(false);

    const handleImageUpload = (e: React.ChangeEvent<HTMLInputElement>) => {
        const file = e.target.files?.[0]
        if (file) {
            setImage(file)
        }
    }

    return { image, handleImageUpload, showImageModal, setShowImageModal }

}
